<template>
  <div>
    <v-card class="elevation-1 mt-4 mb-4">
      <v-card-title class="py-2">
        <span class="primary--text">Customer settings</span>
        <v-spacer></v-spacer>
        <v-switch
          id="is_a_customer_switch"
          hide-details
          class="text-xs-center my-0"
          style="flex: none;"
          :label="`${newCompany.name} is a Customer`"
          @change="
            updateModel(
              'companyStore',
              'newCompany',
              'isCustomer',
              !newCompany.isCustomer
            )
          "
          :input-value="newCompany.isCustomer"
        />
      </v-card-title>

      <v-layout
        v-show="newCompany.isCustomer"
        wrap
        justify-space-between
        row
        px-4
        pb-2
      >
        <v-flex xs12 sm12 md6 px-2>
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="customer_currencies"
            :items="currencies"
            item-value="id"
            item-text="name"
            :value="newCompany.customer.currency_ids"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'customer'],
                'currency_ids',
                $event
              )
            "
            background-color="white"
            multiple
            label="Currencies"
          />
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="customer_payment_terms"
            :items="paymentTerms"
            item-value="id"
            item-text="name"
            :value="newCompany.customer.payment_term_ids"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'customer'],
                'payment_term_ids',
                $event
              )
            "
            background-color="white"
            multiple
            label="Payment terms"
          ></v-autocomplete>

          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="customer_logistic_auditors"
            :items="logisticAuditors"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'customer'],
                'logistic_auditor_ids',
                $event
              )
            "
            :value="newCompany.customer.logistic_auditor_ids"
            background-color="white"
            multiple
            label="Logistic Auditors"
          />
        </v-flex>

        <v-flex xs12 sm12 md6 px-2>
          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="customer_incoterms"
            :items="incoterms"
            item-value="id"
            item-text="name"
            :value="newCompany.customer.incoterm_ids"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'customer'],
                'incoterm_ids',
                $event
              )
            "
            background-color="white"
            multiple
            label="Incoterms"
          ></v-autocomplete>

          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="customer_countries"
            :items="countries"
            item-value="id"
            item-text="name"
            :value="newCompany.customer.country_ids"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'customer'],
                'country_ids',
                $event
              )
            "
            background-color="white"
            multiple
            label="Countries of Destination (of the products)"
          >
            <v-tooltip slot="append" left>
              <v-icon slot="activator" class="help_icon" dark>help</v-icon>
              <span>
                Country of
                <strong>final</strong> destination of the products.
              </span>
            </v-tooltip>
          </v-autocomplete>

          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="customer_ports"
            :items="ports"
            item-value="id"
            item-text="name"
            :value="newCompany.customer.port_ids"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'customer'],
                'port_ids',
                $event
              )
            "
            background-color="white"
            multiple
            label="POD (Port of Destination)"
          >
            <v-tooltip slot="append" left>
              <v-icon slot="activator" class="help_icon" dark>help</v-icon>
              <span>Port of Discharge</span>
            </v-tooltip>
          </v-autocomplete>

          <v-autocomplete
            browser-autocomplete="noautocomplete"
            id="customer_shipping_companies"
            :items="shippingCompanies"
            item-value="id"
            item-text="name"
            @change="
              updateModel(
                'companyStore',
                ['newCompany', 'customer'],
                'company_ids',
                $event
              )
            "
            :value="newCompany.customer.company_ids"
            background-color="white"
            multiple
            label="Unwanted Shipping companies"
          >
            <v-tooltip slot="append" left>
              <v-icon slot="activator" class="help_icon" dark>help</v-icon>
              <span>
                Shipping companies
                <strong>NOT</strong> allowed to load with for this Customer.
              </span>
            </v-tooltip>
          </v-autocomplete>
        </v-flex>
      </v-layout>

      <v-layout
        justify-center
        v-if="newCompany.isCustomer && !newCompany.customer.id"
      >
        <v-alert :value="true" type="info"
          >Save to access documentary instructions</v-alert
        >
      </v-layout>
    </v-card>
    <v-expansion-panel expand v-model="expanded" class="expandPanel my-4">
      <v-expansion-panel-content class="expandPanel">
        <div slot="header">
          <span :class="expanded ? '' : 'primary--text'"
            >Select defaults Customer Parameters</span
          >
        </div>
        <v-flex class="px-4 py-2">
          <v-text-field
            v-model="cust_param_search"
            placeholder="Search Customer Parameters..."
            prepend-inner-icon="search"
            solo
            block
            flat
            hide-details
          />
        </v-flex>
        <v-flex xs12 sm12 md12 xl12 pa-0>
          <v-card card flat light>
            <v-layout wrap row>
              <v-flex
                xs12
                px-4
                pb-4
                v-for="paramsGroup in customerParameterGroups"
                :key="paramsGroup.name"
              >
                <v-card
                  flat
                  v-if="
                    paramsGroup.customer_parameters.filter(
                      (cp) =>
                        !cust_param_search ||
                        cp.name
                          .toLowerCase()
                          .includes(cust_param_search.toLowerCase())
                    ).length > 0
                  "
                >
                  <v-layout justify-end align-center>
                    <v-flex>
                      <div>{{ paramsGroup.name }}</div>
                    </v-flex>

                    <v-flex text-xs-right>
                      <v-btn small flat @click="selectAll(paramsGroup)">
                        <v-icon small>select_all</v-icon>Select all
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>

                  <v-container fluid pa-0>
                    <v-layout wrap row>
                      <v-flex
                        style="border: 1px;"
                        xs12
                        md6
                        lg3
                        pa-1
                        pl-3
                        v-for="params in paramsGroup.customer_parameters.filter(
                          (cp) =>
                            !cust_param_search ||
                            cp.name
                              .toLowerCase()
                              .includes(cust_param_search.toLowerCase())
                        )"
                        :key="params.id"
                      >
                        <v-checkbox
                          height="8"
                          @change="updateCustomerParameters(params.id, $event)"
                          :label="params.name"
                          :input-value="
                            newCompany.customer.customer_parameter_ids.includes(
                              params.id
                            )
                          "
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <collection
      v-show="newCompany.isCustomer && newCompany.customer.id"
      formComponent="documentaryInstructionForm"
      resourceName="documentary_instructions"
      store="companyStore"
      :collectionHeaders="{
        name: 'String',
        document_url: 'String',
      }"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import collection from "../shared/collection";

export default {
  data() {
    return {
      expanded: [false],
      cust_param_search: "",
    };
  },
  components: {
    collection,
  },
  computed: {
    ...mapGetters("commonStore", [
      "currencies",
      "ports",
      "portsFromCountry",
      "paymentTerms",
      "incoterms",
      "customerParameterGroups",
      "customerParameterIdsOfGroup",
      "shippingCompanies",
      "logisticAuditors",
      "countries",
    ]),
    ...mapGetters("companyStore", ["newCompany"]),
  },
  methods: {
    removeCustomerPort(item) {
      this.updateModel(
        "companyStore",
        ["newCompany", "customer"],
        "port_ids",
        this.newCompany.customer.port_ids.filter((port) => port !== item.id)
      );
    },
    updateCustomerParameters(item_id, value) {
      const list =
        value == true
          ? this.newCompany.customer.customer_parameter_ids.concat(item_id)
          : this.newCompany.customer.customer_parameter_ids.filter((e) => {
              return e !== item_id;
            });
      this.updateModel(
        "companyStore",
        ["newCompany", "customer"],
        "customer_parameter_ids",
        list
      );
    },
    selectAll(group) {
      let contain_all_group_ids = true;
      const ids = group.customer_parameters
        .filter(
          (cp) =>
            !this.cust_param_search ||
            cp.name.toLowerCase().includes(this.cust_param_search.toLowerCase())
        )
        .map((e) => {
          return e.id;
        });

      const oldIds = this.newCompany.customer.customer_parameter_ids.filter(
        (e) => {
          return !ids.includes(e);
        }
      );

      ids.forEach((e) => {
        if (!this.newCompany.customer.customer_parameter_ids.includes(e))
          contain_all_group_ids = false;
      });

      const idsToSelect = contain_all_group_ids ? oldIds : ids.concat(oldIds);
      this.updateModel(
        "companyStore",
        ["newCompany", "customer"],
        "customer_parameter_ids",
        idsToSelect
      );
    },
  },
};
</script>
